import { Box, Icon, IconSize, Text } from '@bechtel/gds';
import { useState } from 'react';
import { useAppUser } from '~/components';
import { ProjectListing } from '../project-listing';
import { ProjectSelectorStyled } from './styled';

const ProjectSelector = () => {
  const { userAccount } = useAppUser();
  const defaultProject = userAccount?.defaultProject;
  const [showProjectList, setShowProjectList] = useState(false);

  return (
    <>
      <ProjectSelectorStyled onClick={() => setShowProjectList((prev) => !prev)}>
        <Box mb={{ sm: '100' }}>
          <Text weight="600" size={300} color="grey.1000">
            {defaultProject?.name}
          </Text>
          <Box ml={{ sm: '400' }} mr={{ sm: '200' }}>
            <Icon icon="angle-down" size={IconSize.XSMALL} fillColor="grey.900" iconStyle="solid"></Icon>
          </Box>
        </Box>
        <Text size={200} weight={500} color="grey.600">
          {defaultProject?.jobNumber}
          {defaultProject?.subJobNumber && `-${defaultProject?.subJobNumber}`}
        </Text>
      </ProjectSelectorStyled>
      {showProjectList && <ProjectListing close={() => setShowProjectList(false)} />}
    </>
  );
};

export default ProjectSelector;
